"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = void 0;
const session_1 = require("../../../../session");
const lodash_functions_1 = require("../../../../util/lodash-functions");
const dates_and_calendars_1 = require("../dates-and-calendars");
function Definition(params) {
    return {
        getData(session = (0, session_1.getDefault)()) {
            const datesAndCalendarsProvider = new dates_and_calendars_1.DatesAndCalendarsProvider(session);
            return datesAndCalendarsProvider.getAddPeriods([params]);
        },
        /** @internal */
        getInstrument() {
            return (0, lodash_functions_1.cloneDeep)(params);
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2lwYS9kYXRlcy1hbmQtY2FsZW5kYXJzL2FkZC1wZXJpb2RzL2RlZmluaXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EsaURBQWlEO0FBQ2pELHdFQUE4RDtBQUM5RCxnRUFBbUU7QUFFbkUsU0FBZ0IsVUFBVSxDQUN0QixNQUErQztJQUUvQyxPQUFPO1FBQ0gsT0FBTyxDQUFDLFVBQW1CLElBQUEsb0JBQVUsR0FBRTtZQUNuQyxNQUFNLHlCQUF5QixHQUFHLElBQUksK0NBQXlCLENBQUMsT0FBTyxDQUFDLENBQUM7WUFFekUsT0FBTyx5QkFBeUIsQ0FBQyxhQUFhLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDO1FBQzdELENBQUM7UUFFRCxnQkFBZ0I7UUFDaEIsYUFBYTtZQUNULE9BQU8sSUFBQSw0QkFBUyxFQUFDLE1BQU0sQ0FBQyxDQUFDO1FBQzdCLENBQUM7S0FDSixDQUFDO0FBQ04sQ0FBQztBQWZELGdDQWVDIn0=